<template>
  <span
    class="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-purple-100 text-purple-800"
    title="Item is a Provisional Sum"
  >
    PS
  </span>
</template>
